import * as actions from './../../actions'
import { getApiConfig } from './../../utilities';
import { newFeatureGroupActionTypes as NFGActionTypes } from './NewFeatureGroup/NewFeatureGroupActions';
import { InstallationActionTypes as IActions } from './../Installations/InstallationActions';
import { newInstallationGroupActionTypes as NIGActionTypes } from '../Installations/NewInstallationGroup/NewInstallationGroupActions';
import {PENDING_FEATURE_GROUP, PROJECT_SCOPE_SETUP} from "../../constants/editorNames";
import customEvent from "../../utilities/customEvent";

const {get, post} = getApiConfig('ProjectScope/');

export const ProjectScopeActionTypes = {
  DATA_LOADED: 'project-scope/data-loaded',
  SET_ACTIVE_GROUP: 'project-scope/set-active-group',
  FABRICATOR_SUBSCRIPTIONS_LOADED: 'project-scope/fabricator-subscriptions-loaded',
  UPDATE_FEATURE_GROUPS: 'project-scope/update-feature-groups',
  ADD_NEW_FEATURE_GROUP: 'project-scope/add-new-feature-group',
  SET_MODE: 'project-scope/set-mode'
};

export function setMode(mode) {
  return (dispatch) => {
    return dispatch({
      type: ProjectScopeActionTypes.SET_MODE,
      payload: mode
    });
  }
}

export function fetchData(type = 'Project Scope', CustomMessage = null) {
  return (dispatch, getState) => {
    let state = getState();
    const {auth, asCustomer} = state;
    let fabricatorId = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
    return dispatch(actions.loadingDialog_show(true, 'Loading...', CustomMessage ? CustomMessage : `Loading ${type} Data...`))
      .then(() => getApiConfig('Subscriptions/').get(`Get/${fabricatorId}`)
      .then(subs => dispatch({
          type: ProjectScopeActionTypes.FABRICATOR_SUBSCRIPTIONS_LOADED,
          payload: subs
        })
      ))
      .then(() => get(`GetProjectScopeData?fabricatorId=${fabricatorId}&masterFabricatorId=${auth.masterFabricatorId}`))
      .then(response => {
        document.dispatchEvent(customEvent("pre-load-project-scope-data"));
        // console.log("MEGA response", response);
        dispatch({
          type: ProjectScopeActionTypes.DATA_LOADED,
          payload: response
        });
        dispatch({
          type: NIGActionTypes.LOAD,
          payload: {
            installationGroups: response.installationGroups,
            installationUnits: response.installationUnits,
            filterGroups: response.filterGroups
          }
        });
        dispatch({
          type: IActions.DATA_LOADED,
          payload: response
        });
        dispatch({
          type: NFGActionTypes.LOAD,
          payload: {
            pendingFeatureGroups: response.pendingFeatureGroups,
            featureGroupMeta: response.featureGroupMeta
          }
        });
        document.dispatchEvent(customEvent("post-load-project-scope-data"));
      })
      .then(() => dispatch(actions.loadingDialog_show(false)));
  }
}

export function setActiveFeatureGroupName(group) {
  return (dispatch) => {
    return dispatch({
      type: ProjectScopeActionTypes.SET_ACTIVE_GROUP,
      payload: group
    });
  }
}

export function deleteFeature(feature, force = false) {
  return (dispatch, getState) => {
    const { search } = getState();
    const { post } = getApiConfig('Dashboard_Feature');

    dispatch(actions.loadingDialog_show(true, 'Checking Feature Usage...', 'Looking up feature usage, this will take just a moment.'))
      .then(() => post({
        featureDefinitionId: feature.id
      }, 'CheckFeature'))
      .then(response => {
        let msg = "<div class='message-box-content-scrollable'>Are you sure you wish to delete this feature?<br />";
        if(response.featureInUse) {
          msg += "This feature is currently in use by the following " + response.fabsUsingFeature.length + " fabricator" + (response.fabsUsingFeature.length == 1 ? "" : "s") + ":<br />";
          response.fabsUsingFeature.sort();
          for(let i = 0; i < response.fabsUsingFeature.length; i++) {
            let fab = response.fabsUsingFeature[i];
            msg += fab + "<br />";
          }
        } else {
          msg += "This feature is not currently in use.<br />";
        }
        msg += "</div>";
        dispatch(actions.loadingDialog_show(false));
        dispatch(actions.messageBox_Show(true, 'system', 'Delete Feature?', msg, [
          {
            text: 'Yes',
            subtext: 'Delete the feature',
            onClick: () => {
              dispatch(actions.messageBox_Show()); //reset to default props (not visible by default)
              dispatch(actions.loadingDialog_show(true, 'Deleting Feature...', 'Deleting your feature. This will take just a moment.'));
              post({
                featureDefinitionId: feature.id
              }, "DeleteFeature")
                .then(() => dispatch(fetchData()))
                .then(() => dispatch(actions.setSearchTerm(search.term + " "))) //triggering a change to the search term forces the stone page to update
                .then(() => dispatch(actions.setSearchTerm(search.term))) //revert to previous term after triggering change
                .then(() => dispatch(actions.loadingDialog_show(false)));
            }
          },
          {
            text: 'No',
            subtext: 'Do not delete the feature',
            onClick: () => dispatch(actions.messageBox_Show()) //reset to default props (not visible by default)
          }
        ]));
      });
  }
}

export const updateFeatureGroups = (updatedFeatureGroup) => {
  return (dispatch, getState) => {
    // 1) turn on the loader
    dispatch(actions.loadingDialog_show(true));

    // 2) update frontend
    dispatch({
      type: ProjectScopeActionTypes.UPDATE_FEATURE_GROUPS,
      payload: { updatedFeatureGroup }
    });

    // 3) update backend
    const state = getState();
    const { auth, asCustomer } = state;
    const api = getApiConfig('dashboard');

    const save_data = [{
      data: [{
        id: updatedFeatureGroup.name,
        values: {
          enabled: updatedFeatureGroup.enabled,
          visible: updatedFeatureGroup.visible,
          customImageUrl: updatedFeatureGroup.customImageUrl,
          customDisplayName: updatedFeatureGroup.customDisplayName,
          customDescription: updatedFeatureGroup.customDescription,
          unitText: updatedFeatureGroup.unitText
        }
      }],
      data_type: PROJECT_SCOPE_SETUP
    }];
    const fabricator_id = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
    api.post({ fabricator_id, master_fabricator_id: auth.masterFabricatorId, model: save_data }, 'save')
      .then(() => {
        // 4) turn off the loader
        dispatch(actions.loadingDialog_show(false));
      });
  }
};

export const addNewFeatureGroup = (newBaseFeatureGroup) => {
  const newFeatureGroup = {
    isComplex: false,
    name: newBaseFeatureGroup.name,
    description: newBaseFeatureGroup.description,
    features: [],
    enabled: true,
    visible: true,
    customDisplayName: newBaseFeatureGroup.name,
    customDescription: newBaseFeatureGroup.description,
    unitText: newBaseFeatureGroup.unitText,
    customImageUrl: newBaseFeatureGroup.image,
    image: newBaseFeatureGroup.image
  };
  return (dispatch, getState) => {
    // 1) turn on the loader
    dispatch(actions.loadingDialog_show(true));

    // 2) update frontend
    dispatch({
      type: ProjectScopeActionTypes.ADD_NEW_FEATURE_GROUP,
      payload: { newFeatureGroup }
    });

    // 3) update backend
    const state = getState();
    const { auth, asCustomer } = state;
    const api = getApiConfig('dashboard');

    const save_data = [{
      data: [{
        ids: [],
        values: newBaseFeatureGroup
      }],
      data_type: PENDING_FEATURE_GROUP
    }];
    const fabricator_id = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
    api.post({ fabricator_id, master_fabricator_id: auth.masterFabricatorId, model: save_data }, 'save')
      .then(() => {
        // 4) turn off the loader
        dispatch(actions.loadingDialog_show(false));
      });
  }
};
